export default () => (
  <path d="M18.21 19.27c.3.3.77.3 1.06 0 .3-.29.3-.77 0-1.06L13.06 12l6.21-6.21c.3-.3.3-.77 0-1.06a.75.75 0 0 0-1.06 0L12 10.94 5.79 4.73a.75.75 0 0 0-1.06 0c-.3.29-.3.77 0 1.06L10.94 12l-6.21 6.21c-.3.3-.3.77 0 1.06.29.3.77.3 1.06 0L12 13.06l6.21 6.21Z" />
);
